import { Component, inject } from '@angular/core';
import { ToastService, Toast } from '../../../core/services/toast.service';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [IconComponent],
  template: `
    <div class="fixed top-24 right-4 z-[60] flex flex-col gap-3 max-w-sm w-full pointer-events-none">
      @for (toast of toastService.toasts(); track toast.id) {
        <div
          class="pointer-events-auto animate-slide-right rounded-xl shadow-lg border px-4 py-3 flex items-start gap-3"
          [class]="getToastClasses(toast)"
        >
          <!-- Icon -->
          <span class="mt-0.5">
            @switch (toast.type) {
              @case ('success') { <app-icon name="check-circle" [size]="18" /> }
              @case ('error') { <app-icon name="x-circle" [size]="18" /> }
              @case ('warning') { <app-icon name="alert-triangle" [size]="18" /> }
              @case ('info') { <app-icon name="info" [size]="18" /> }
            }
          </span>

          <!-- Message -->
          <p class="text-sm font-medium flex-1">{{ toast.message }}</p>

          <!-- Close -->
          <button
            class="text-gray-400 hover:text-gray-600 transition-colors cursor-pointer"
            (click)="toastService.dismiss(toast.id)"
          >
            <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      }
    </div>
  `,
})
export class ToastComponent {
  readonly toastService = inject(ToastService);

  getToastClasses(toast: Toast): string {
    const base = 'bg-white';
    switch (toast.type) {
      case 'success':
        return `${base} border-primary-200 text-primary-800`;
      case 'error':
        return `${base} border-red-200 text-red-800`;
      case 'warning':
        return `${base} border-amber-200 text-amber-800`;
      case 'info':
        return `${base} border-blue-200 text-blue-800`;
      default:
        return base;
    }
  }
}
